<template>
  <modal-dialog
    :visible="dialog"
    max-width="600"
    container-class="pa-0 ma-0"
    card-class="pa-0 ma-0"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    scrollable
  >
    <welcome-step-welcome
      v-if="step===0"
      ref="step_0"
      @advance="finishStep(0)"
    />
    <v-stepper
      v-else
      v-model="step"
      class="elevation-0"
      non-linear
      alt-labels
      @change="stepChanged"
    >
      <v-stepper-header
        class="elevation-0"
        flat
      >
        <template v-for="n in steps">
          <v-stepper-step
            :key="`${n}-step`"
            color="blue"
            :complete="completedSteps[n]"
            :step="n"
            edit-icon="$complete"
            :editable="editable"
          >
            {{ stepLabels[n] }}
          </v-stepper-step>
          <v-divider
            v-if="n !== steps"
            :key="n"
          />
        </template>
      </v-stepper-header>
      <v-divider />

      <v-stepper-items>
        <v-stepper-content :step="1">
          <welcome-step-account
            ref="step_1"
            @advance="finishStep(1)"
          />
        </v-stepper-content>
        <v-stepper-content :step="2">
          <welcome-step-tables
            ref="step_2"
            @advance="finishStep(2)"
          />
        </v-stepper-content>
        <v-stepper-content step="3">
          <welcome-step-hours
            ref="step_3"
            @advance="finishStep(3)"
          />
        </v-stepper-content>
        <v-stepper-content step="4">
          <welcome-step-online-alt
            ref="step_4"
          />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <template #actions>
      <v-btn
        v-if="skipSteps[step]"
        text
        color="error"
        @click="skip"
      >
        {{ $t('button.skip') }}
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="step !== steps"
        color="primary"
        @click="submit"
      >
        {{ $t('button.continue') }}
      </v-btn>
      <v-btn
        v-else
        color="success"
        @click="nextStep"
      >
        {{ $t('button.start_using_guestplan') }}
      </v-btn>
    </template>
  </modal-dialog>
</template>

<script lang="ts">
import WelcomeStepWelcome from '@/components/views/onboarding/WelcomeStepWelcome.vue';
import WelcomeStepAccount from '@/components/views/onboarding/WelcomeStepAccount.vue';
import WelcomeStepTables from '@/components/views/onboarding/WelcomeStepTables.vue';
import WelcomeStepOnlineAlt from '@/components/views/onboarding/WelcomeStepOnline.vue';
import WelcomeStepHours from '@/components/views/onboarding/WelcomeStepHours.vue';
import DialogClosable from '@/mixins/dialog-closable';

import Vue from 'vue';

export default Vue.extend({
  name: 'Welcome',
  components: {
    WelcomeStepWelcome,
    WelcomeStepAccount,
    WelcomeStepTables,
    WelcomeStepOnlineAlt,
    WelcomeStepHours,
  },
  mixins: [DialogClosable],
  props: { },
  data() {
    return {
      step: 0,
      steps: 4,
      editable: true,
      completedSteps: [false, false, false, false, false],
      skipSteps: [false, true, false, false, false],
      stepLabels: ['',
        this.$i18n.t('title.account'),
        this.$i18n.t('title.tables'),
        this.$i18n.t('title.opening_hours'),
        this.$i18n.t('title.finished')],
    };
  },
  computed: { },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if (value) this.$emit('open');
      },
    },
  },
  methods: {
    finishStep(s: number) {
      this.completedSteps[s] = true;
      this.nextStep();
    },
    skip() {
      this.nextStep();
    },
    submit() {
      const stepComponent = this.$refs[`step_${this.step}`] as any;
      stepComponent.submit();
    },
    nextStep() {
      if (this.step === this.steps) {
        this.$emit('close');
        return;
      }
      this.step += 1;
      this.stepChanged(this.step);
    },
    stepChanged(step: number) {
      if (step !== 4) return;
      const stepComponent = this.$refs[`step_${this.step}`] as any;
      stepComponent.reset();
    },
  },
});
</script>
